import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp, loadMoreList, tool, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, loadMoreList, tool, commonData],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        reason: ''
      },
      rules: {
        reason: [{
          required: true,
          message: "请输入原因",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.formData.id = data;
                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    _this2.$api.cancelTour(_this2.formData).then(function (res) {
                      if (res.code == 200) {
                        _this2.$message.success("取消成功!");

                        _this2.dialogFormVisible = false;

                        _this2.getList(_this2.paramsData.page);
                      } else {
                        _this2.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};